
export class AysClinicStaffing {

  public static fromObject(obj: any): AysClinicStaffing {
    const medical = AysClinicStaffingMedical.fromObject(obj.medical);
    const nursing = AysClinicStaffingNursing.fromObject(obj.nursing);

    return new AysClinicStaffing(medical, nursing);
  }

  constructor(
    public medical: AysClinicStaffingMedical,
    public nursing: AysClinicStaffingNursing
  ) {
  }
}

export class AysClinicStaffingMedical {

  public static fromObject(obj: any = {}): AysClinicStaffingMedical {
    const medicalSpecialists = obj.docsWithoutInpatientDocs.medicalSpecialists || {};
    const nonSpecialists = obj.docsWithoutInpatientDocs.nonSpecialists || {};

    return new AysClinicStaffingMedical(
      obj.total,
      medicalSpecialists,
      nonSpecialists,
      obj.inpatientDocs
    );
  }

  private readonly _normalizedYears: string[];

  constructor(
    public total: {[year: number]: number} = {},
    public medicalSpecialists: {[year: number]: number} = {},
    public nonSpecialists: {[year: number]: number} = {},
    public inpatientDocs: {[year: number]: number} = {},
  ) {
    let normalizedYears = Object.keys(this.total);

    normalizedYears = normalizedYears.concat(
      Object.keys(this.medicalSpecialists)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.nonSpecialists)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.inpatientDocs)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    this._normalizedYears = normalizedYears;
  }

  public chartData(fieldName: string, label: string, color: string): any {
    const field = this[fieldName];
    const data = this._normalizedYears.map(year => field[year]);
    const borderWidth = fieldName === 'total' ? 3 : 1;

    return {
      label: label,
      data: data,
      lineTension: 0,
      fill: false,
      borderWidth: borderWidth,
      borderColor: color,
      backgroundColor: color
    };
  }

  public hasData(fieldName: string): boolean {
    const field = this[fieldName];
    const years = Object.keys(field);

    return years.filter(year => !!field[year]).length > 0;
  }

  get normalizedYears(): string[] {
    return this._normalizedYears;
  }
}

export class AysClinicStaffingNursing {

  public static fromObject(obj: any = {}): AysClinicStaffingNursing {
    return new AysClinicStaffingNursing(
      obj.total,
      obj.deliveryNurses,
      obj.enrolledChildrenNurses,
      obj.enrolledNurses,
      obj.geriatricNurses,
      obj.hospitalPorters,
      obj.licensedPracticalNurses,
      obj.scrubNurses
    );
  }

  private readonly _normalizedYears: string[];

  constructor(
    public total: {[year: number]: number},
    public deliveryNurses: {[year: number]: number} = {},
    public enrolledChildrenNurses: {[year: number]: number} = {},
    public enrolledNurses: {[year: number]: number} = {},
    public geriatricNurses: {[year: number]: number} = {},
    public hospitalPorters: {[year: number]: number} = {},
    public licensedPracticalNurses: {[year: number]: number} = {},
    public scrubNurses: {[year: number]: number} = {}
  ) {
    let normalizedYears = Object.keys(this.total);

    normalizedYears = normalizedYears.concat(
      Object.keys(this.deliveryNurses)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.enrolledChildrenNurses)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.enrolledNurses)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.geriatricNurses)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.hospitalPorters)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.licensedPracticalNurses)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    normalizedYears = normalizedYears.concat(
      Object.keys(this.scrubNurses)
        .filter(year => normalizedYears.indexOf(year) === -1)
    );

    this._normalizedYears = normalizedYears;
  }

  public chartData(fieldName: string, label: string, color: string): any {
    const field = this[fieldName];
    const data = this._normalizedYears.map(year => field[year]);
    const borderWidth = fieldName === 'total' ? 3 : 1;

    return {
      label: label,
      data: data,
      lineTension: 0,
      fill: false,
      borderWidth: borderWidth,
      borderColor: color,
      backgroundColor: color
    };
  }

  public hasData(fieldName: string): boolean {
    const field = this[fieldName];
    const years = Object.keys(field);

    return years.filter(year => !!field[year]).length > 0;
  }

  get normalizedYears(): string[] {
    return this._normalizedYears;
  }
}

export const AYS_STAFFING_YEARS: number[] = [2012, 2013, 2014, 2015, 2016];
